/**
 * @packageDocumentation
 * @module f1/string
 */

export interface Trim {
  /**
   * Remove whitespace from the start and end of a string
   *
   * @public
   * @function f1.trim
   * @param s any string
   * @example
   *
   * ```ts
   * f1.trim('   1') === '1'
   * f1.trim('1   ') === '1'
   * f1.trim(' 1  ') === '1'
   * ```
   */
  (s: string): string;
}

/**
 * @see Trim
 */
export default (s: string) => s.trim();
